export enum ClientBookingSurveyQuestionType {
  Numeric = 'numeric',
  BinaryChoice = 'binary choice',
  MultipleChoice = 'multiple choice',
}

export type ClientBookingSurveyQuestionAnswer = {
  id: number;
  text: string;
  shouldEndSurvey: boolean;
};

export type ClientBookingSurveyQuestion = {
  answers: ClientBookingSurveyQuestionAnswer[];
  userFillInAnswer: ClientBookingSurveyQuestionAnswer;
  id: number;
  leftHelperText?: string;
  rightHelperText?: string;
  text: string;
  type: ClientBookingSurveyQuestionType;
  showSubmitButton?: boolean;
  showUserFillInOption?: boolean;
  handleTrack: Function;
};

export type ClientBookingSurveyNewProps = {
  onSubmit: (answers: AnswersByQuestionId) => void;
  questions: ClientBookingSurveyQuestion[];
  trackingParams?: {},
};

export type AnswersByQuestionId = {
  [key: number]: string;
};

export type SurveyQuestionProps = {
  activeQuestion: ClientBookingSurveyQuestion;
  activeQuestionIndex: number;
  handleSubmit: (answer: ClientBookingSurveyQuestionAnswer, userFillInText?: string) => void;
};
